import { render } from "./ButtonComponent.vue?vue&type=template&id=0bd2af6d&ts=true&lang=html"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__